import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { NotificationBannerItem } from "@redotech/redo-web/arbiter-components/notification/redo-notification-banner";
import { isBeforeNow } from "@redotech/util/date";
import { useContext } from "react";
import { useIntercom } from "react-use-intercom";
import { ActionRequiredSeverity } from "./action-required-notification";

export function useTeamDeletion(): {
  severity: ActionRequiredSeverity;
  item: NotificationBannerItem;
} | null {
  const team = useContext(TeamContext);

  const intercom = useIntercom();

  const anonymizationDate = team?.teamAnonymization?.anonymizationDate;

  const hasAnonymizationDatePassed =
    !!anonymizationDate && isBeforeNow(new Date(anonymizationDate));

  if (!anonymizationDate || hasAnonymizationDatePassed) {
    return null;
  }

  return {
    severity: ActionRequiredSeverity.Critical,
    item: {
      id: "team-deletion",
      type: "error",
      message: `This merchant account is scheduled for deletion on ${new Date(
        anonymizationDate,
      ).toLocaleDateString()} due to inactivity. If you believe this is in error, please let us know.`,
      actions: [
        {
          actionType: "button",
          text: "Contact support",
          hierarchy: "primary",
          onClick: () => intercom.showNewMessage(),
        },
      ],
    },
  };
}
